import { Empty as AntdEmpty } from "antd/es";
import React, { type FC } from "react";

export interface EmptyProps {
	description?: string;
	className?: string;
}

export const Empty: FC<React.PropsWithChildren<EmptyProps>> = ({ description = "No Data", ...rest }) => (
	<AntdEmpty description={description} image={AntdEmpty.PRESENTED_IMAGE_SIMPLE} {...rest} />
);
